import { useMapStoreStateToClientState } from '@/hooks/useMapStoreStateToClientState';
import type { Store } from '@/stores';

export default function useStateOfUI(store: Store) {
  return useMapStoreStateToClientState(store, (store) => ({
    isPageLoading: store.uiStore.isPageLoading,
    setPageLoading: store.uiStore.setPageLoading,
    isDashboardDrawerOpen: store.uiStore.isDashboardDrawerOpen,
    setDashboardDrawerOpen: store.uiStore.setDashboardDrawerOpen,
    setError: store.uiStore.setError,
    getError: store.uiStore.getError,
    errorsMap: store.uiStore.errorsMap,
    getErrors: store.uiStore.getErrors,
    is12HoursTimeFormat: store.uiStore.is12HoursTimeFormat,
    set12HoursTimeFormat: store.uiStore.set12HoursTimeFormat,
    isShowSavedSection: store.uiStore.isShowSavedSection,
    setShowSavedSection: store.uiStore.setShowSavedSection,
    isFlightSubmitError: store.uiStore.isFlightSubmitError,
    setOpenDashboardDrawer: store.uiStore.setDashboardDrawerOpen,
    isFareFamilyUpgraded: store.uiStore.isOutboundFareUpgraded || store.uiStore.isInboundFareUpgraded,
  }));
}
